export default (theme) => ({
    root: theme.softpro.safeBox,
    title: {
        marginBottom: '1em',
    },
});
